import { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import { INotifications, TNotification } from '../../core/notifications';
import { Notifications } from '../notifications';

type PageNotificationsRenderProps = {
  notifyStore: INotifications;
  children?: (notifications: ReactNode) => ReactNode;
};

export const NotificationsRender = observer(
  ({ notifyStore, children }: PageNotificationsRenderProps) => {
    const hasNotifications = notifyStore.messages.length > 0;

    const onClose = (messageId: Pick<TNotification, 'id'>) =>
      notifyStore.removeMessage(messageId);

    return hasNotifications ? (
      <>
        {children ? (
          children(
            <Notifications messages={notifyStore.messages} onClose={onClose} />
          )
        ) : (
          <Notifications messages={notifyStore.messages} onClose={onClose} />
        )}
      </>
    ) : null;
  }
);
